import React, { useState } from "react";
import ChurchLogo from "../../assets/ChurchLogo.png";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import axios from "axios";
import { api_url } from "../../data";
import { ThreeDots } from "react-loader-spinner";
import { useAuth } from "../../context/Auth";

const ChurchSettings = ({ churchDetails }) => {
    const {requestWithAuth} = useAuth();
  const data = churchDetails;
  const [updateData, setUpdateData] = useState({});
  const [submitting, setSubmitting] = useState(false);

  console.log(data);

  // HANDLE CHANGE
  const handleChange = (e) => {
    setUpdateData({
      ...updateData,
      [e.target.name]: e.target.value,
    });
  };

  // SUBMIT FORM
  const submitForm = async (e) => {
    setSubmitting(true)
    e.preventDefault();
    const formData = new FormData();
    Object.keys(updateData).forEach((key) => {
      formData.append(key, updateData[key]);
    });

    try {
        const response = await requestWithAuth(
          "/accounts/church-details/",
          "PUT",
          formData,
          {
            "Content-Type": "multipart/form-data",
          }
        )
        Swal.fire({
            icon: "success",
            title: "Success",
            text: "Church Details Updated Successfully",
          }).then(() => {
            window.location.reload();
          });
      
    } catch (error) {
      console.log(error);
      toast.error("An error occurred.");
    }finally{
        setSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header Section */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Church Details
        </h2>
        <p className="text-gray-600">
          Update your church information and settings
        </p>
      </div>

      <form onSubmit={(e) => submitForm(e)} className="space-y-8">
        {/* Church Logo Section */}
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-start space-x-6">
            {/* Logo Preview */}
            <div className="flex-shrink-0">
              <div className="w-24 h-24 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden">
                {data?.church_logo ? (
                  <img
                    src={`${api_url}${data.church_logo}`}
                    alt="Church Logo"
                    className="w-full h-full object-cover rounded-lg"
                  />
                ) : (
                  <svg
                    className="w-8 h-8 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                )}
              </div>
            </div>

            {/* Upload Section */}
            <div className="flex-1">
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Church Logo
              </h3>
              <label
                htmlFor="image-upload"
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
                Upload Image
              </label>
              <input
                onChange={(e) => {
                  setUpdateData({
                    ...updateData,
                    [e.target.name]: e.target.files[0],
                  });
                }}
                type="file"
                name="church_logo"
                className="hidden"
                id="image-upload"
                accept="image/png,image/jpeg"
              />
              <p className="mt-2 text-sm text-gray-500">
                We support PNGs and JPEGs under 10MB
              </p>
            </div>
          </div>
        </div>

        {/* Form Fields */}
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Church Name */}
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Church Name
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                required
                value={
                  updateData?.church_name
                    ? updateData?.church_name
                    : data?.church_name || ""
                }
                onChange={(e) => handleChange(e)}
                name="church_name"
                placeholder="Enter church name"
              />
            </div>

            {/* Phone Number */}
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Phone Number
              </label>
              <input
                type="tel"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                required
                value={
                  updateData?.church_phone_number
                    ? updateData?.church_phone_number
                    : data?.church_phone_number || ""
                }
                onChange={(e) => handleChange(e)}
                name="church_phone_number"
                placeholder="Enter phone number"
              />
            </div>

            {/* Email */}
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                required
                value={
                  updateData?.church_email
                    ? updateData?.church_email
                    : data?.church_email || ""
                }
                onChange={(e) => handleChange(e)}
                name="church_email"
                placeholder="Enter email address"
              />
            </div>

            {/* Location */}
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Location
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                required
                value={
                  updateData?.church_location
                    ? updateData?.church_location
                    : data?.church_location || ""
                }
                onChange={(e) => handleChange(e)}
                name="church_location"
                placeholder="Enter church location"
              />
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end">
          {submitting ? (
            <div className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 cursor-not-allowed">
              <ThreeDots
                height="20"
                width="20"
                radius="9"
                color="#ffffff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
              <span className="ml-2">Saving...</span>
            </div>
          ) : (
            <button
              type="submit"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 shadow-sm"
            >
              <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              Save Changes
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ChurchSettings;
